namespace $ { $mol_style_attach( "bog/fragile/demo/case/case.view.css",
 "[bog_fragile_demo_case] [mol_labeler_content] > * {\n\tdisplay: flex;\n\tgap: .75rem;\n}\n"
) }